import { ARTICLES_PER_PAGE } from 'features/Blog/utils/blogConstants'
import { pageHref } from 'features/Blog/utils/pageHref'

export const getBlogIndexSchema = (page: number) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'We Feed Raw Blog - The Raw Report',
  url: `https://wefeedraw.com${pageHref(page)}`,
  description: 'Tips and advice for a healthy dog life.',
  mainEntity: {
    '@type': 'ItemList',
    numberOfItems: `${ARTICLES_PER_PAGE}`,
    itemListOrder: 'ItemListOrderDescending',
  },
})
